import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';

import DashboardSection from 'components/DashboardSection/DashboardSection';

import APNCountsDataMapView from 'views/Admin/APNCountsDataMapView';
import APNLookupView from 'views/Admin/APNLookupView';
import FarmedApnsDataMapView from 'views/Admin/FarmedApnsDataMapView';
import PropertyLookupAdminView from 'views/Admin/PropertyLookupAdminView';
import ZipCodesDataMapView from 'views/Admin/ZipCodesDataMapView';

const DATA_MAP_TABS = {
  APN_COUNTS: 'APN Counts',
  FARMED_APNS: 'Farmed APNs',
  ZIP_CODES: 'Zip Codes',
  APN_LOOKUP: 'APN Lookup',
  PROPERTY_LOOKUPS: 'Property Lookups',
};

const TAB_TO_QUERY_PARAM = {
  [DATA_MAP_TABS.APN_COUNTS]: 'apn-counts',
  [DATA_MAP_TABS.FARMED_APNS]: 'farmed-apns',
  [DATA_MAP_TABS.ZIP_CODES]: 'zip-codes',
  [DATA_MAP_TABS.APN_LOOKUP]: 'apn-lookup',
  [DATA_MAP_TABS.PROPERTY_LOOKUPS]: 'property-lookups',
};

const QUERY_PARAM_TO_TAB = {
  'apn-counts': DATA_MAP_TABS.APN_COUNTS,
  'farmed-apns': DATA_MAP_TABS.FARMED_APNS,
  'zip-codes': DATA_MAP_TABS.ZIP_CODES,
  'apn-lookup': DATA_MAP_TABS.APN_LOOKUP,
  'property-lookups': DATA_MAP_TABS.PROPERTY_LOOKUPS,
};

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));

const AdminDataMapPage = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const availableTabs = Object.values(DATA_MAP_TABS);

  const activeTabFromQuery = React.useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return QUERY_PARAM_TO_TAB[searchParams.get('tab')] ?? DATA_MAP_TABS.APN_COUNTS;
  }, [location.search]);

  const [activeTab, setActiveTab] = React.useState(activeTabFromQuery);

  React.useEffect(() => {
    setActiveTab(activeTabFromQuery);
  }, [activeTabFromQuery]);

  const onTabChange = (tab) => {
    setActiveTab(tab);

    const searchParams = new URLSearchParams(location.search);
    const tabParam = TAB_TO_QUERY_PARAM[tab];

    if (tabParam === TAB_TO_QUERY_PARAM[DATA_MAP_TABS.APN_COUNTS]) {
      searchParams.delete('tab');
    } else {
      searchParams.set('tab', tabParam);
    }

    history.replace({
      pathname: location.pathname,
      search: searchParams.toString() ? `?${searchParams.toString()}` : '',
    });
  };

  return (
    <div className={classes.root}>
      <DashboardSection
        sectionName="Data Warehouse"
        tabs={availableTabs}
        activeTab={activeTab}
        setActiveTab={onTabChange}
      />
      {activeTab === DATA_MAP_TABS.APN_COUNTS && <APNCountsDataMapView />}
      {activeTab === DATA_MAP_TABS.FARMED_APNS && <FarmedApnsDataMapView />}
      {activeTab === DATA_MAP_TABS.ZIP_CODES && <ZipCodesDataMapView />}
      {activeTab === DATA_MAP_TABS.APN_LOOKUP && <APNLookupView />}
      {activeTab === DATA_MAP_TABS.PROPERTY_LOOKUPS && <PropertyLookupAdminView />}
    </div>
  );
};

export default AdminDataMapPage;
